import { Popup } from 'es6/libs/popup'
import { Defaults } from 'es-decorators'
import { ItemsPopupView } from 'es6/views/popups/items-popup-view'
import Backbone from 'init/backbone'

/**
 * Попап с информацией о недоступности быстрой доставки
 */
@Defaults({
  el: '.js-fast-delivery-popup',
})
export class FastDeliveryPopupView extends ItemsPopupView {
  /**
   * @inheritDoc
   */
  run () {
    this.initPopup()
    this.listenTo(Backbone, 'show-fast-delivery-popup', this.render)
  }

  /**
   * Показать попап
   * @param {Item} model Модель товара
   * @param {jQuery} $qty Элемент qty-view, с которого был добавлен товар
   */
  render (model, $qty) {
    this.$('.js-fast-delivery-balance').html(model.get('fast_delivery_balance'))

    let qtyPosition = $qty.offset()
    this.$el.css({
      left: qtyPosition.left - 2,
      top: qtyPosition.top - this.$el.height() - 40,
    })
    this.open()
  }

  /**
   * Открываем попап
   */
  open () {
    // костыль для лебедевского попапа
    setTimeout(this.popup.open.bind(this.popup), 1)
  }

  /**
   * Инициализация попапа
   */
  initPopup () {
    this.popup = new Popup(this.$el)
  }
}
